import n from "react";
import e from "@leafygreen-ui/icon/dist/ImportantWithCircle";
import r from "@leafygreen-ui/icon/dist/InfoWithCircle";
import o from "@leafygreen-ui/icon/dist/Warning";
import i from "@leafygreen-ui/icon/dist/CheckmarkWithCircle";
import t from "@leafygreen-ui/icon/dist/X";
import { css as l, cx as a } from "@leafygreen-ui/emotion";
import { palette as c } from "@leafygreen-ui/palette";
import d from "@leafygreen-ui/icon-button";
import { jsx as g } from "@emotion/react";

function s(n, e, r) {
  return e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}

function f() {
  return f = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
      }
    }

    return n;
  }, f.apply(this, arguments);
}

function b(n, e) {
  if (null == n) return {};

  var r,
      o,
      i = function (n, e) {
    if (null == n) return {};
    var r,
        o,
        i = {},
        t = Object.keys(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || (i[r] = n[r]);
    }

    return i;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (i[r] = n[r]);
    }
  }

  return i;
}

function u(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var p,
    m,
    h,
    x,
    k,
    y,
    v,
    w,
    O,
    j,
    C,
    I,
    N,
    R,
    W,
    B,
    P,
    S,
    D = ["variant", "dismissible", "onClose", "image", "children", "className"],
    L = {
  Info: "info",
  Warning: "warning",
  Danger: "danger",
  Success: "success"
},
    z = l(p || (p = u(["\n  position: relative;\n  display: flex;\n  min-height: 40px;\n  padding: 10px 12px 10px 20px;\n  border-width: 1px 1px 1px 0px;\n  border-style: solid;\n  border-radius: 12px;\n  font-size: 13px;\n  line-height: 20px;\n  font-family: 'Euclid Circular A', Helvetica, Arial, sans-serif; // TODO: Refresh – remove when fonts are updated\n\n  &:before {\n    content: '';\n    position: absolute;\n    width: 13px;\n    top: -1px;\n    bottom: -1px;\n    left: 0px;\n    border-radius: 12px 0px 0px 12px;\n  }\n"]))),
    E = l(m || (m = u(["\n  &:focus {\n    color: ", ";\n    outline: 2px solid ", ";\n    border: 2px solid ", ";\n  }\n"])), c.gray.dark3, c.blue.light1, c.white),
    A = l(h || (h = u(["\n  flex-shrink: 0;\n"]))),
    H = l(x || (x = u(["\n  cursor: pointer;\n"]))),
    M = l(k || (k = u(["\n  // this margin is set to control text alignment with the base of the renderedImage\n  margin-top: 3px;\n  margin-bottom: 3px;\n\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n"]))),
    T = (s(R = {}, L.Info, {
  body: l(y || (y = u(["\n      color: ", ";\n      border-color: ", ";\n      border-left-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background: linear-gradient(\n          to left,\n          transparent 6px,\n          ", " 6px\n        );\n      }\n    "])), c.blue.dark2, c.blue.light2, c.blue.base, c.blue.light3, c.blue.base),
  dismissButton: l(v || (v = u(["\n      color: ", ";\n\n      &:active,\n      &:hover {\n        color: ", ";\n\n        &:before {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        &:before {\n          background-color: ", ";\n        }\n      }\n    "])), c.blue.dark2, c.blue.dark2, c.blue.light2, c.blue.light2)
}), s(R, L.Warning, {
  body: l(w || (w = u(["\n      color: ", ";\n      border-color: ", ";\n      border-left-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background: linear-gradient(\n          to left,\n          transparent 6px,\n          ", " 6px\n        );\n      }\n    "])), c.yellow.dark2, c.yellow.light2, c.yellow.base, c.yellow.light3, c.yellow.base),
  dismissButton: l(O || (O = u(["\n      color: ", ";\n\n      &:active,\n      &:hover {\n        color: ", ";\n\n        &:before {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        &:before {\n          background-color: ", ";\n        }\n      }\n    "])), c.yellow.dark2, c.yellow.dark2, c.yellow.light2, c.yellow.light2)
}), s(R, L.Danger, {
  body: l(j || (j = u(["\n      color: ", ";\n      border-color: ", ";\n      border-left-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background: linear-gradient(\n          to left,\n          transparent 6px,\n          ", " 6px\n        );\n      }\n    "])), c.red.dark2, c.red.light2, c.red.base, c.red.light3, c.red.base),
  dismissButton: l(C || (C = u(["\n      color: ", ";\n\n      &:active,\n      &:hover {\n        color: ", ";\n\n        &:before {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        &:before {\n          background-color: ", ";\n        }\n      }\n    "])), c.red.dark2, c.red.dark2, c.red.light2, c.red.light2)
}), s(R, L.Success, {
  body: l(I || (I = u(["\n      color: ", ";\n      border-color: ", ";\n      border-left-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background: linear-gradient(\n          to left,\n          transparent 6px,\n          ", " 6px\n        );\n      }\n    "])), c.green.dark2, c.green.light2, c.green.base, c.green.light3, c.green.dark1),
  dismissButton: l(N || (N = u(["\n      color: ", ";\n\n      &:active,\n      &:hover {\n        color: ", ";\n\n        &:before {\n          background-color: ", ";\n        }\n      }\n\n      &:focus {\n        &:before {\n          background-color: ", ";\n        }\n      }\n    "])), c.green.dark2, c.green.dark2, c.green.light2, c.green.light2)
}), R),
    X = (s(W = {}, L.Info, {
  color: c.blue.base,
  icon: r
}), s(W, L.Warning, {
  color: c.yellow.dark2,
  icon: e
}), s(W, L.Danger, {
  color: c.red.base,
  icon: o
}), s(W, L.Success, {
  color: c.green.dark1,
  icon: i
}), W),
    q = function q(n, e) {
  var r = {
    marginLeft: void 0,
    marginRight: void 0
  };
  return n ? (r.marginLeft = "17px", r.marginRight = "4px", e && (r.marginRight = "".concat(28, "px"))) : (r.marginLeft = "13px", r.marginRight = "10px", e && (r.marginRight = "".concat(32, "px"))), l(B || (B = u(["\n    align-self: center;\n    flex-grow: 1;\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), r.marginLeft, r.marginRight);
};

function F(e) {
  var r = e.variant,
      o = void 0 === r ? L.Info : r,
      i = e.dismissible,
      c = void 0 !== i && i,
      s = e.onClose,
      p = void 0 === s ? function () {} : s,
      m = e.image,
      h = e.children,
      x = e.className,
      k = b(e, D),
      y = X[o],
      v = y.icon,
      w = y.color,
      O = m ? n.cloneElement(m, {
    className: M
  }) : g(v, {
    fill: w,
    className: a(A, l(P || (P = u(["\n          margin-top: 3px;\n        "]))))
  });
  return g("div", f({
    role: "alert",
    className: a(z, T[o].body, x)
  }, k), O, g("div", {
    className: q(null != m, c)
  }, h), c && g(d, {
    className: a(A, H, l(S || (S = u(["\n              margin-top: -3px;\n              left: 8px;\n            "]))), T[o].dismissButton, E),
    "aria-label": "Close Message",
    onClick: p
  }, g(t, null)));
}

export { L as Variant, F as default };